<template>
    <div class="new-upload-version" :style="{height: isApprove ? 'calc(100% - 227px)' : '100%'}">
        <el-scrollbar style="height: 100%;" ref="scrollbar">
            <el-form ref="formRef" :model="formData" :rules="formRules" label-width="130px" label-position="left">
                <el-row :gutter="15">
                    <el-col :span="12">
                        <ocr-card-upload
                        :showAbnormalFlag="showAbnormalFlag.idCardFileUrl"
                        :isNewOcrUpload="true"
                        :supplierCode="supplierTab.supplierCode"
                        ref="ocrCardUpload"
                        :cardTitle="'身份证(人像面)'"
                        :flag="uploadList[0].fileName + '#' + uploadList[0].fileUrl + '#' + uploadList[0].fileId"
                        :ocr="uploadList[0].ocrFlag"
                        :label="uploadList[0].label"
                        :imgValue="uploadForm.idCardFileUrl"
                        :imgExampleValue="imgExample.idCardFileUrl"
                        :previewSrcList="uploadForm.idCardFileUrl ? Object.values(uploadForm) : Object.values(imgExample)"
                        :disabled="isApprove"
                        :drag="true"
                        :isRequired="uploadList[0].isRequired"
                        :showDel="true"
                        @delete="delFile('idCardFile')"
                        @uploadSuccess="handleUploadSuccess"
                        @aiCounter="aiCounter"
                        @preview="previewFile"
                        />
                        <!-- 司机姓名、身份证号编辑下置灰，不允许编辑 -->
                        <el-form-item label="身份证号" prop="idCard">
                            <el-input v-model.trim="formData.idCard" :disabled="!!formData.driverId || isApprove" placeholder="请输入身份证号" @blur="handleBlurIdCard(false)"></el-input>
                        </el-form-item>
                        <!-- 占位符 -->
                        <!-- <el-form-item class="customFormItem" v-if="isExistDriverInfo">
                            <div class="tip"></div>
                        </el-form-item> -->
                        <!-- 司机姓名、身份证号编辑下置灰，不允许编辑 -->
                        <el-form-item label="身份证起始日期" prop="idCardStartDate" class="idCardStartDate">
                            <el-date-picker
                                value-format="yyyy-MM-dd"
                                v-model="formData.idCardStartDate"
                                type="date"
                                class="time-type"
                                placeholder="请选择身份证起始日期"
                                :disabled="!isValidIdCard || isApprove || !formData.idCardBottomSideFileUrl"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="身份证到期日期" prop="idCardEndDate" class="idCardEndDate">
                            <el-date-picker
                                value-format="yyyy-MM-dd"
                                v-model="formData.idCardEndDate"
                                type="date"
                                class="time-type"
                                placeholder="请选择身份证到期日期"
                                :disabled="!isValidIdCard || isApprove || !formData.idCardBottomSideFileUrl"
                            ></el-date-picker>
                        </el-form-item>
                        <ocr-card-upload
                        :showAbnormalFlag="showAbnormalFlag.drivingLicenceFileUrl"
                        :isNewOcrUpload="true"
                        :supplierCode="supplierTab.supplierCode"
                        ref="ocrCardUpload"
                        :cardTitle="'驾驶证'"
                        :flag="uploadList[2].fileName + '#' + uploadList[2].fileUrl + '#' + uploadList[2].fileId"
                        :ocr="uploadList[2].ocrFlag"
                        :label="uploadList[2].label"
                        :imgValue="uploadForm.drivingLicenceFileUrl"
                        :imgExampleValue="imgExample.drivingLicenceFileUrl"
                        :previewSrcList="uploadForm.drivingLicenceFileUrl ? Object.values(uploadForm) : Object.values(imgExample)"
                        :disabled="isApprove"
                        :drag="true"
                        :isRequired="uploadList[2].isRequired"
                        :showDel="true"
                        @delete="delFile('drivingLicenceFile')"
                        @uploadSuccess="handleUploadSuccess"
                        @aiCounter="aiCounter"
                        @preview="previewFile"
                        />
                        <el-form-item label="准驾车型" prop="driveType">
                            <el-input v-model.trim="formData.driveType" :disabled="!isValidIdCard || isApprove || !formData.drivingLicenceFileUrl" placeholder="请输入准驾车型"></el-input>
                        </el-form-item>
                        <el-form-item label="驾驶证号" prop="drivingLicence">
                            <el-input v-model.trim="formData.drivingLicence" :disabled="!isValidIdCard || isApprove" placeholder="请输入驾驶证号"></el-input>
                        </el-form-item>
                        <el-form-item label="驾驶证起始日期" prop="driveStartDate">
                            <el-date-picker
                                value-format="yyyy-MM-dd"
                                v-model="formData.driveStartDate"
                                type="date"
                                class="time-type"
                                placeholder="请选择驾驶证起始日期"
                                :disabled="!isValidIdCard || isApprove || !formData.drivingLicenceFileUrl"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="驾驶证到期日期" prop="driveEndDate">
                            <el-date-picker
                                value-format="yyyy-MM-dd"
                                v-model="formData.driveEndDate"
                                type="date"
                                class="time-type"
                                placeholder="请选择到期日期"
                                :disabled="!isValidIdCard || isApprove || !formData.drivingLicenceFileUrl"
                                :picker-options="pickerOptionsDrivingLicenceEnd"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="驾驶证初次领证日期" prop="dateIssue">
                            <el-date-picker
                                    :disabled="!isValidIdCard || isApprove"
                                    value-format="yyyy-MM-dd"
                                    v-model="formData.dateIssue"
                                    type="date"
                                    class="time-type"
                                    placeholder="请选择驾驶证初次领证日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="驾驶证签发机关" prop="driverLicenseAuthority">
                            <el-input v-model.trim="formData.driverLicenseAuthority" :disabled="!isValidIdCard || isApprove" placeholder="请输入驾驶证签发机关"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <ocr-card-upload
                        :showAbnormalFlag="showAbnormalFlag.idCardBottomSideFileUrl"
                        :isNewOcrUpload="true"
                        :supplierCode="supplierTab.supplierCode"
                        ref="ocrCardUpload"
                        :cardTitle="'身份证(国徽面)'"
                        :flag="uploadList[1].fileName + '#' + uploadList[1].fileUrl + '#' + uploadList[1].fileId"
                        :ocr="uploadList[1].ocrFlag"
                        :label="uploadList[1].label"
                        :imgValue="uploadForm.idCardBottomSideFileUrl"
                        :imgExampleValue="imgExample.idCardBottomSideFileUrl"
                        :previewSrcList="uploadForm.idCardBottomSideFileUrl ? Object.values(uploadForm) : Object.values(imgExample)"
                        :disabled="isApprove"
                        :drag="true"
                        :isRequired="uploadList[1].isRequired"
                        :showDel="true"
                        @delete="delFile('idCardBottomSideFile')"
                        @uploadSuccess="handleUploadSuccess"
                        @aiCounter="aiCounter"
                        @preview="previewFile"
                        />
                        <el-form-item label="司机姓名" prop="driverName" class="driverName">
                            <el-input v-model.trim="formData.driverName" maxlength="50" :disabled="!isValidIdCard || !!formData.driverId || isApprove || !formData.idCardFileUrl" placeholder="请输入司机姓名" @input="handleInput($event, 'driverName')"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号码" prop="phoneNo" ref="refidCardNo">
                            <el-input v-model.trim="formData.phoneNo" maxlength="11" :disabled="!isValidIdCard || isApprove || (!!supplier && !!driverInfo.phoneNo)" placeholder="请输入手机号码" @input="handleInput($event, 'phoneNo')"></el-input>
                        </el-form-item>
                        <!-- <el-form-item class="customFormItem" v-if="isExistDriverInfo">
                            <div class="tip">司机信息已存在系统中，可以<span @click.stop="handleViewDriverInfoPanel">查看</span>确定是否直接使用</div>
                        </el-form-item> -->
                        <div class="form-item-gap"></div>
                        <ocr-card-upload
                        :showAbnormalFlag="showAbnormalFlag.empCertificateFileUrl"
                        :isNewOcrUpload="true"
                        :supplierCode="supplierTab.supplierCode"
                        ref="ocrCardUpload"
                        :cardTitle="'从业资格证'"
                        :flag="uploadList[3].fileName + '#' + uploadList[3].fileUrl + '#' + uploadList[3].fileId"
                        :ocr="uploadList[3].ocrFlag"
                        :label="uploadList[3].label"
                        :imgValue="uploadForm.empCertificateFileUrl"
                        :imgExampleValue="imgExample.empCertificateFileUrl"
                        :previewSrcList="uploadForm.empCertificateFileUrl ? Object.values(uploadForm) : Object.values(imgExample)"
                        :disabled="isApprove"
                        :drag="true"
                        :isRequired="empCertificateRequired"
                        :showDel="true"
                        @delete="delFile('empCertificateFile')"
                        @uploadSuccess="handleUploadSuccess"
                        @aiCounter="aiCounter"
                        @preview="previewFile"
                        />
                        <div class="emp-tips" v-if="empCertificateRequired && !formData.empCertificateFileUrl">请注意，准驾车型为A/B照司机必须上传从业资格证！</div>
                        <el-form-item label="从业资格证号" prop="empCertificate">
                            <el-input v-model.trim="formData.empCertificate" :disabled="!isValidIdCard || isApprove" placeholder="请输入从业资格证号"></el-input>
                        </el-form-item>
                        <el-form-item label="从业资格证到期日期" prop="empCertificateEndDate">
                            <el-date-picker
                                value-format="yyyy-MM-dd"
                                v-model="formData.empCertificateEndDate"
                                type="date"
                                class="time-type"
                                placeholder="请选择到期日期"
                                :disabled="!isValidIdCard || isApprove || !formData.empCertificateFileUrl"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="从业资格类别" prop="empCertificateType">
                            <!-- <MSelect
                                :disabled="!isValidIdCard || isApprove"
                                :optionNum="'EMP_CERTIFICATE_TYPE'"
                                :value="formData.empCertificateType"
                                :filterable="true"
                                :multiple="true"
                                @input="val => handleSelect(val, 'empCertificateType')"
                            ></MSelect> -->
                            <el-input :maxlength="64" v-model.trim="formData.empCertificateType" :disabled="!isValidIdCard || isApprove" placeholder="请输入从业资格类别"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="isLegalPersonSupplier && delegateVisible">
                    <el-form-item label="委派函" class="delegate">
                        <el-radio v-model="formData.delegateOnline" :label="DELEGATE_TYPE.ONLINE" :disabled="!isValidIdCard || formData.approvalStatus === APPROVE_PEDDING || isApprove" @change="radioChange">线上</el-radio>
                        <el-radio v-model="formData.delegateOnline" :label="DELEGATE_TYPE.OFFLINE" :disabled="!isValidIdCard || formData.approvalStatus === APPROVE_PEDDING || isApprove" @change="radioChange">线下</el-radio>
                    </el-form-item>
                </el-row>
                <!-- 委派函 -->
                <el-row>
                    <!-- 非法人，或委派函选择线下时显示出来 -->
                    <div class="delegate-wrapper" v-show="!isLegalPersonSupplier || formData.delegateOnline === DELEGATE_TYPE.OFFLINE">
                        <el-form-item label="委派函" prop="delegateFileName" class="delegateFile">
                            <el-input
                            v-model="formData.delegateFileName"
                            :disabled="!isValidIdCard || formData.approvalStatus === APPROVE_PEDDING || isApprove"
                            placeholder="点击上传附件"
                            readonly
                            style="width: 296px;"
                            />
                            <el-popover placement="right" width="500" trigger="click" @show="showpopover(uploadList[4].example)">
                                <div style="text-align: center">
                                    <img :src="imgSrcPathObj[uploadList[4].example]" style="height: 100%">
                                </div>
                                <span slot="reference" v-popover:popover1 class="form-item-btn">示例</span>
                            </el-popover>
                            <span class="form-item-btn" @click="previewFile(uploadList[4].fileUrl)" v-if="formData[uploadList[4].fileUrl]">预览</span>
                            <span class="form-item-btn" @click="handleDownloadTemplate('driverDelegateTemplate.docx', '委派函模板', 'docx')">下载模板</span>
                            <register-upload
                                :uploadDisplayType="''"
                                :sizeLimit="6"
                                :typeLimit="{reg: '^\.(jpg|jpeg|png)$', warningText: 'jpg、jpeg、png'}"
                                :accept="'image/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf'"
                                :flag="uploadList[4].fileName + '#' + uploadList[4].fileUrl + '#' + uploadList[4].fileId"
                                :disabled="!isValidIdCard || isApprove || formData.approvalStatus === APPROVE_PEDDING"
                                :ocr="uploadList[4].ocrFlag"
                                class="upload-item-icon three-btn"
                                @uploadSuccess="handleUploadSuccess"
                            ></register-upload>
                        </el-form-item>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="委派开始时间" prop="delegateStartTime" class="delegateStartTime" style="margin-right: 15px">
                                    <el-date-picker
                                        value-format="yyyy-MM-dd"
                                        v-model="formData.delegateStartTime"
                                        type="date"
                                        placeholder="请选择委派开始时间"
                                        :disabled="!isValidIdCard || formData.approvalStatus === APPROVE_PEDDING || isApprove"
                                        style="width: 100%"
                                        :picker-options="pickerOptionsDelegateStartTime"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="委派结束时间" prop="delegateEndTime" class="delegateEndTime" style="margin-right: 15px">
                                    <el-date-picker
                                    value-format="yyyy-MM-dd"
                                    v-model="formData.delegateEndTime"
                                    type="date"
                                    placeholder="请选择委派结束时间"
                                    :disabled="!isValidIdCard || formData.approvalStatus === APPROVE_PEDDING || isApprove"
                                    style="width: 100%"
                                    :picker-options="pickerOptionsDelegateEndTime"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <!-- 选择签署人，法人，且委派函选择线上时显示出来 -->
                    <div class="delegate-wrapper" v-show="isLegalPersonSupplier && formData.delegateOnline === DELEGATE_TYPE.ONLINE">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="选择签署人" prop="stamperCode" class="stamperCode">
                                    <el-input readonly v-model="formData.stamperName" :disabled="!isValidIdCard || formData.approvalStatus === APPROVE_PEDDING || isApprove" placeholder="选择签署人">
                                        <template v-slot:append>
                                            <el-button icon="el-icon-s-custom" :disabled="!isValidIdCard || formData.approvalStatus === APPROVE_PEDDING || isApprove" @click="detaliSearch(stamperParams)"></el-button>
                                        </template>
                                        <template v-slot:suffix v-if="formData.approvalStatus !== APPROVE_PEDDING">
                                            <i class="el-input__icon el-icon-circle-close" v-if="formData.stamperName" @click="resetAdvanceValue('stamperCode', 'stamperName')"></i>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="签署人手机" prop="stamperMobile" style="margin-right: 15px">
                                    <el-input readonly v-model="formData.stamperMobile" :disabled="!isValidIdCard || formData.approvalStatus === APPROVE_PEDDING || isApprove" placeholder="请输入签署人手机号码" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="委派开始时间" prop="delegateStartTime" class="delegateStartTime" style="margin-right: 15px">
                                    <el-date-picker
                                        value-format="yyyy-MM-dd"
                                        v-model="formData.delegateStartTime"
                                        type="date"
                                        placeholder="请选择委派开始时间"
                                        :disabled="!isValidIdCard || formData.approvalStatus === APPROVE_PEDDING || isApprove"
                                        style="width: 100%"
                                        :picker-options="pickerOptionsDelegateStartTime"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="委派结束时间" prop="delegateEndTime" class="delegateEndTime" style="margin-right: 15px">
                                    <el-date-picker
                                    value-format="yyyy-MM-dd"
                                    v-model="formData.delegateEndTime"
                                    type="date"
                                    placeholder="请选择委派结束时间"
                                    :disabled="!isValidIdCard || formData.approvalStatus === APPROVE_PEDDING || isApprove"
                                    style="width: 100%"
                                    :picker-options="pickerOptionsDelegateEndTime"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="签署方式" prop="pushType" class="push-type-form-item">
                                    <MSelect
                                        :optionNum="'SRM_SUPPLIER_DELEGATE_TYPE'"
                                        :value="formData.pushType"
                                        :disabled="pushTypeDisabled"
                                        :filterable="true"
                                        @input="val => handleSelect(val, 'pushType')"
                                    ></MSelect>
                                    <div class="push-type-tip">{{ pushTypeTip[formData.pushType] }}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-row>
                <!-- 在途联系信息 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="在途联系类别" prop="onWayContactCategory" style="margin-right: 15px" class="onWayContactCategory">
                            <el-select v-model="formData.onWayContactCategory" clearable placeholder="请选择在途联系类别" :disabled="!isValidIdCard || isApprove" style="width: 100%;" @change="handleSelect($event, 'onWayContactCategory')">
                                <el-option label="司机" :value="ON_WAY_CONTACT_CGR.DRIVER"></el-option>
                                <el-option label="供应商" :value="ON_WAY_CONTACT_CGR.SUPPLIER"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="在途联系人姓名" prop="onWayContactName" style="margin-right: 15px">
                            <SrmAdvance
                                v-if="isLgtSupCgr"
                                :disabled="!isValidIdCard || isApprove"
                                :mValue="formData.onWayContactName"
                                :params="owcnParams"
                                :formData="{ supplierCode: supplierTab.supplierCode }"
                                @getAdvanceValue="getOwcnAdvanceValue"
                            />
                            <el-input v-else v-model.trim="formData.onWayContactName" clearable :disabled="!isValidIdCard || isApprove" placeholder="请输入在途联系人姓名" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="在途联系人手机" prop="onWayContactPhone" style="margin-right: 15px">
                            <el-input v-model.trim="formData.onWayContactPhone" clearable :disabled="!isValidIdCard || isApprove || isLgtSupCgr" placeholder="在途联系人电话" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                    <el-form-item label="联系地址" prop="countryCode" class="country">
                        <el-select v-model.trim="formData.countryCode" :disabled="!isValidIdCard || isApprove" placeholder="国家" filterable @change="val => { handleAdressSelect(val, 'country') }">
                            <el-option
                                v-for="(item, index) in countryOptions"
                                :key="item.value + '_' + index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="provinceCode" class="province">
                        <el-select v-model="formData.provinceCode" :disabled="!isValidIdCard || isApprove" placeholder="省份" filterable @change="val => { handleAdressSelect(val, 'province') }">
                            <el-option
                                v-for="(item, index) in provinceOptions"
                                :key="item.value + '_' + index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="cityCode" class="city">
                        <el-select v-model="formData.cityCode" :disabled="!isValidIdCard || isApprove" placeholder="城市" filterable @change="val => { handleAdressSelect(val, 'city') }">
                            <el-option
                                v-for="(item, index) in cityOptions"
                                :key="item.value + '_' + index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="22">
                    <el-form-item prop="familyAddress">
                        <el-input v-model.trim="formData.familyAddress" :disabled="!isValidIdCard || isApprove" placeholder="请输入详细地址"></el-input>
                    </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-scrollbar>
        <div v-if="showBottomShadow" class="scroll-bottom-shadow"></div>
        <!-- 输入身份证系统带出司机信息弹窗 -->
        <!-- <driver-info-modal ref="driverInfoModalRef" :driverInfo="driverInfo" @sure="handleSetFormData"></driver-info-modal> -->
        <!-- 高级弹窗组件 -->
        <advance-dialog ref="advanceDialog" @confirm="detaliSearchSure"></advance-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import MSelect from '@/components/lots/otpSelect2';
import OcrCardUpload from '../../../../../../../components/ocrCardUpload/Index.vue';
import registerUpload from '../../../../../../../components/upload/Index.vue';
import advanceDialog from '@/components/lots/otpAdvanceDialog';
import MCheckBox from '../../../../../../../components/MCheckBox.vue';
import SrmAdvance from '../../../../../../../components/srmAdvance/index.vue';
// import DriverInfoModal from './DriverInfoModal.vue';
import { LOGISTICS_SUPPLIER, PUSH_TYPE, COMPANY, PERSON, ON_WAY_CONTACT_CGR } from '../../../../../../../constant/constant.js';
import { uploadList } from '../uploadListConfig.js';
import { formData, formRules, DELEGATE_TYPE, stamperParams } from './config.js';
import {
    pickerOptionsDelegateStartDate,
    pickOptionsDelegateEndDate,
    pickerOptionsDrivingLicenceStart,
    pickerOptionsDrivingLicenceEnd
} from './util.js';
import methods,{INIT_OCR_RESULT_MAP} from './methods.js';
import { identityVerify } from '../../../../../../../constant/formRegular.js';
import { cloneDeep } from 'lodash';
import { dictWithUrl } from '@/components/lots/api'

const pushTypeTip = {
    [PUSH_TYPE.ALONE]: '(提交后，即时推送司机委派函给供应商签署，供应商签署完成后，系统自动推送司机签署)',
    [PUSH_TYPE.BATCH]: '(提交后，在委派函管理中发起多个司机委派函的签署，供应商签署完成后，系统再自动推送司机签署)',
}

const owcnParams = {
    name: '在途联系人姓名',
    value: 'onWayContactName',
    advanceLabel: '在途联系人姓名',
    type: 'advance',
    advanceConfig: [
        { prop: 'contacts', value: '联系人姓名' },
        { prop: 'contactsMobile', value: '手机号' },
    ],
    tableConfig: [
        { prop: 'contacts', value: '联系人姓名' },
        { prop: 'contactsMobile', value: '手机号' },
        { prop: 'onWayContactFlag', value: '是否在途联系人', type: 'select', optionsKey: 'ON_WAY_CONTACT_FLAG' },
    ],
    advanceCascade: 'supplierCode',
    cbParams: ['contacts#onWayContactName', 'contactsMobile#onWayContactPhone'],
    method: 'post',
    advanceUrl: '/supplier/onWayContactsInfoPage',
    prefix: 'api-srm-web',
}

export default {
    name: 'newUploadVersion',
    components: { MSelect, OcrCardUpload, registerUpload, advanceDialog, MCheckBox, SrmAdvance },
    props: {
        imgSrcPathObj: {
            type: Object,
            default() {
                return {};
            }
        },
        id: {
            type: [String, Number],
            default() {
                return '';
            }
        },
        supplierTab: {
            type: Object,
            default() {
                return {};
            }
        },
        form: {
            type: Object,
            default() {
                return {};
            }
        },
        openAddOrEditDialog: {
            type: Boolean,
            default() {
                return false;
            }
        },
        isLegalPersonSupplier: {
            type: Boolean,
            default: false
        },
        approvalStatus: {
            type: String,
            default() {
                return '';
            }
        },
    },
    data() {
        return {
            // isExistDriverInfo: false, // 是否存在司机信息
            searchedIdCard: '', // 查询过的司机信息身份证号
            driverInfo: {}, // 存储新增时默认值、编辑时司机详情接口返回值、或身份证查询司机接口带出来的部分司机信息
            isApprove: false, // 是否在审批状态下
            delegateOnline: '', // 当前委派函必填项0 == 委派函、委派时间必填  1 == 选择签署人、委派时间必填
            APPROVE_PEDDING: '10', // 审批状态为审批中
            uploadList,
            pickerOptionsDrivingLicenceStart: pickerOptionsDrivingLicenceStart(this),
            pickerOptionsDrivingLicenceEnd: pickerOptionsDrivingLicenceEnd(this),
            pickerOptionsDelegateStartTime: pickerOptionsDelegateStartDate(this),
            pickerOptionsDelegateEndTime: pickOptionsDelegateEndDate(this),
            formData: { ...formData }, // 表单数据
            formRules: formRules(this), // 表单校验规则
            fileObj: {},
            ON_WAY_CONTACT_CGR,
            DELEGATE_TYPE,
            stamperParams,
            owcnParams, // 在途联系人姓名advance配置
            // 上传的文件图片
            uploadForm: {
                idCardFileUrl: '', // 身份证(人像面)
                idCardBottomSideFileUrl: '', // 身份证(国徽面)
                drivingLicenceFileUrl: '', // 驾驶证
                empCertificateFileUrl: '' // 从业资格证
            },
            // 示例封面图片
            imgExample: {
                idCardFileUrl: require('./example/idCardFile.jpg'), // 身份证(人像面)
                idCardBottomSideFileUrl: require('./example/idCardBottomSideFile.jpg'), // 身份证(国徽面)
                drivingLicenceFileUrl: require('./example/drivingLicenceFile.jpg'), // 驾驶证
                empCertificateFileUrl: require('./example/empCertificateFile.jpg') // 从业资格证
            },
            countryOptions: [],
            provinceOptions: [],
            cityOptions: [],
            ocrData: { // OCR识别出的数据，用于判断提交时是否走审批
                idCard: null,
                driverName: null,
                idCardEndDate: null,
                driveType: null,
                driveStartDate: null,
                driveEndDate: null,
                drivingLicence: null,
            },
            // OCR识别出的部分字段缓存，用于在查询不到数据时进行覆盖值
            ocrCache: {
                driverName: null,
                familyAddress: null,
            },
            delegateVisible: false, // 委派函选择是否可见
            pushTypeTip,
            showBottomShadow: true, // 底部灰色背景显示隐藏
            scrollWrapELe: null, // 滚动事件需要的dom
            scrollViewEle: null, // 滚动事件需要的dom
            ocrResultMap: cloneDeep(INIT_OCR_RESULT_MAP),
            validateOcrData: [
                {field: 'idCardEndDate', label: '身份证到期日期', fileProp: 'idCardBottomSideFileUrl', licenseName: '身份证国徽面'},
                {field: 'idCardStartDate', label: '身份证起始日期', fileProp: 'idCardBottomSideFileUrl', licenseName: '身份证国徽面'},
                {field: 'empCertificateEndDate', label: '从业资格证到期日期', fileProp: 'empCertificateFileUrl', licenseName: '从业资格证'},
                {field: 'empCertificate', label: '从业资格证号', fileProp: 'empCertificateFileUrl', licenseName: '从业资格证'},
                {field: 'empCertificateType', label: '从业资格类别', fileProp: 'empCertificateFileUrl', licenseName: '从业资格证'},
                {field: 'drivingLicence', label: '驾驶证号', fileProp: 'drivingLicenceFileUrl', licenseName: '驾驶证'},
                {field: 'driveType', label: '准驾车型', fileProp: 'drivingLicenceFileUrl', licenseName: '驾驶证'},
                {field: 'driveStartDate', label: '驾驶证起始日期', fileProp: 'drivingLicenceFileUrl', licenseName: '驾驶证'},
                {field: 'driveEndDate', label: '驾驶证到期日期', fileProp: 'drivingLicenceFileUrl', licenseName: '驾驶证'},
                {field: 'dateIssue', label: '驾驶证初次领证日期', fileProp: 'drivingLicenceFileUrl', licenseName: '驾驶证'},
                {field: 'driverLicenseAuthority', label: '驾驶证签发机关', fileProp: 'drivingLicenceFileUrl', licenseName: '驾驶证'},
                {field: 'idCard', label: '身份证号', fileProp: 'idCardFileUrl', licenseName: '身份证人像面'},
                {field: 'driverName', label: '司机姓名', fileProp: 'idCardFileUrl', licenseName: '身份证人像面'},
            ],
            ocrQualityCount: {
                idCardFileUrl: 0,
                idCardBottomSideFileUrl: 0,
                drivingLicenceFileUrl: 0,
                empCertificateFileUrl: 0,
            },
            backupFormData: {},
            riskTypeSwitch: false,
            editToolSwitch: false,
            dict: {},
            showAbnormalFlag: {
                drivingLicenceFileUrl: false,
                empCertificateFileUrl: false,
                idCardFileUrl: false,
                idCardBottomSideFileUrl: false,
            },
            empSwitch: false,
        };
    },
    computed: {
        formDiff(){
            if(this.id){
                //编辑才需要判断表单是否有变化
                return JSON.stringify(this.formData).replace(/""/g, 'null') === JSON.stringify(this.backupFormData).replace(/""/g, 'null')
            }else{
                return false
            }
        },
        // 校验是否为有效身份证号
        isValidIdCard() {
            return this.formData.idCard && identityVerify.test(this.formData.idCard)
        },
        // 签署方式置灰条件
        pushTypeDisabled() {
            let { approvalStatus, phoneNo, stamperCode, delegateStartTime, delegateEndTime }  = this.formData
            // 流程状态是审批中，或当前操作是审批详情，或手机号、委派函相关字段无值，或签署方式原本有值时，手机号、委派函相关字段未作改变，字段置灰
            const disabled = approvalStatus === this.APPROVE_PEDDING || this.isApprove ||
                !phoneNo || !stamperCode || !delegateStartTime || !delegateEndTime ||
                (
                    !!this.driverInfo.pushType &&
                    this.driverInfo.phoneNo === phoneNo &&
                    this.driverInfo.stamperCode === stamperCode &&
                    this.driverInfo.delegateStartTime === delegateStartTime &&
                    this.driverInfo.delegateEndTime === delegateEndTime
                )
            if (disabled) {
                this.formData.pushType = this.driverInfo.pushType
            }
            return disabled
        },
        // 判断是否为物流法人供应商
        isLgtPptSup() {
            return this.supplierTab.supplierType === LOGISTICS_SUPPLIER && this.supplierTab.propertyNature === COMPANY
        },
        // 判断是否为物流个体供应商
        isLgtPsSup() {
            return this.supplierTab.supplierType === LOGISTICS_SUPPLIER && this.supplierTab.propertyNature === PERSON
        },
        // 物流法人/个体供应商，在途联系类别为供应商
        isLgtSupCgr() {
            return (this.isLgtPptSup || this.isLgtPsSup) && this.formData.onWayContactCategory === ON_WAY_CONTACT_CGR.SUPPLIER
        },
        empCertificateRequired(){
            const driveType = this.formData.driveType && this.formData.driveType.toLocaleUpperCase()
            return !!(driveType && ['A', 'B'].includes(driveType[0]))
        },
        ...mapState(['supplier']),
    },
    watch: {
        'formData.empCertificateFileUrl'(v){
            this.formRules.empCertificateEndDate[0].required = !!v;
        },
        formDiff(v){
            this.$emit('hasDiff', v)
        },
    },
    methods: {
        ...methods,
        detaliSearch(advanceCascade) {
            const isSupplier = this.supplier;
            const supplierCode = isSupplier ? isSupplier.supplierCode : this.$route.query.supplierCode;
            this.$refs.advanceDialog.show(true, advanceCascade, { supplierCode });
        },
        // 选中高级组件值后回调
        detaliSearchSure(data) {
            Object.keys(data).forEach(k => {
                this.$set(this.formData, k, data[k]);
            });
        },
        // 重置高级组件
        resetAdvanceValue(code, name) {
            this.$set(this.formData, code, '');
            this.$set(this.formData, name, '');
        },
        // 切换委派函线上线下
        radioChange(val) {
            // 个体时委派函控制不作调整
            if (!this.isLegalPersonSupplier) {
                return false;
            }
            this.formData.delegateStartTime = '';
            this.formData.delegateEndTime = '';
            this.formData.pushType = '';
            this.formRules.stamperCode[0].required = val === DELEGATE_TYPE.ONLINE;
            this.formRules.stamperMobile[0].required = val === DELEGATE_TYPE.ONLINE;
            this.formRules.delegateFileName[0].required = val === DELEGATE_TYPE.OFFLINE;
            this.formRules.delegateStartTime[0].required = val === DELEGATE_TYPE.OFFLINE || val === DELEGATE_TYPE.ONLINE;
            this.formRules.delegateEndTime[0].required = val === DELEGATE_TYPE.OFFLINE || val === DELEGATE_TYPE.ONLINE;
            this.formRules.pushType[0].required = val === DELEGATE_TYPE.ONLINE;
        },
        handleInput(value, prop) {
            // 在途联系类别 是 司机
            if (this.formData.onWayContactCategory === ON_WAY_CONTACT_CGR.DRIVER) {
                if (prop === 'driverName') {
                    // 司机姓名 赋值给 在途联系人姓名
                    this.formData.onWayContactName = value
                } else if (prop === 'phoneNo') {
                    // 司机手机号 赋值给 在途联系人手机号
                    this.formData.onWayContactPhone = value
                }
            }
        },
        handleSelect(value, prop) {
            this.formData[prop] = value;
            if (prop === 'onWayContactCategory') {
                if (this.isLgtPptSup && value === ON_WAY_CONTACT_CGR.SUPPLIER) {
                    this.setOnWayContact()
                } else if (this.isLgtPsSup && value === ON_WAY_CONTACT_CGR.SUPPLIER) {
                    this.formData.onWayContactName = ''
                    this.formData.onWayContactPhone = ''

                } else {
                    this.formData.onWayContactName = this.formData.driverName

                    this.formData.onWayContactPhone = this.formData.phoneNo
                }
            }
        },
        scrollEvent() {
            if (!this.scrollWrapELe || !this.scrollViewEle) {
                return false
            }
            // 加多1像素是为了兼容页面缩放后的效果
            this.showBottomShadow = (this.scrollWrapELe.scrollTop + this.scrollWrapELe.offsetHeight + 1) < this.scrollViewEle.offsetHeight
        },
        addScrollEvent() {
            this.scrollWrapELe = this.$refs.scrollbar.wrap
            this.scrollViewEle = document.querySelector('.new-upload-version .el-scrollbar__view')
            this.scrollWrapELe.addEventListener('scroll', this.scrollEvent, false)
        },
        removeScrollEvent() {
            this.scrollWrapELe.removeEventListener('scroll', this.scrollEvent)
        },
    },
    mounted() {
        dictWithUrl('EMP_CERTIFICATE_TYPE').then(res => {
            if (res && +res.code === 0) {
                this.dict = res.data
            }
        })
        this.addScrollEvent()
    },
    beforeDestroy() {
        this.removeScrollEvent()
    },
};
</script>
<style lang="less">
@import url("./newUploadVersion.less");
</style>
